import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { T } from "@/lib/i18n";
import { computeCompletion } from "@/lib/completion";
import { CheckCircle2, Circle, ArrowRight, Sparkles } from "lucide-react";

export const CompletionBadge = ({ cv, lang, onGoTo }) => {
  const t = T[lang];
  const { missing, done, total, pct } = computeCompletion(cv, lang);
  const ready = missing.length === 0;
  const color = ready ? "bg-green-50 text-green-700 border-green-200" : pct >= 60 ? "bg-amber-50 text-amber-700 border-amber-200" : "bg-[#fadbd8]/60 text-[#c0392b] border-[#c0392b]/30";
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="completion-badge" className={`flex items-center gap-1.5 whitespace-nowrap text-xs font-semibold rounded-full border px-2.5 py-1 transition-colors hover:brightness-95 ${color}`}>
          {ready ? <CheckCircle2 className="h-3.5 w-3.5" /> : <Circle className="h-3.5 w-3.5" />}
          <span>{t.completion} {pct}%</span>
          {!ready && <span className="hidden sm:inline text-[10px] opacity-70">({done}/{total})</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent data-testid="completion-popover" align="end" className="w-80 p-4">
        <div className="text-xs font-bold uppercase tracking-wide text-[#1a2e4a] mb-2 flex items-center gap-1.5">
          <Sparkles className="h-3.5 w-3.5 text-[#c0392b]" /> {t.completion} · {done}/{total}
        </div>
        {ready ? (
          <div data-testid="completion-ready" className="text-sm text-green-700">{t.completionReady}</div>
        ) : (
          <>
            <p className="text-xs text-[#64748b] mb-2">{t.completionHint}</p>
            <ul className="space-y-1">
              {missing.map((m) => (
                <li key={m.key}>
                  <button data-testid={`completion-missing-${m.key}`} onClick={() => onGoTo(m.step)} className="w-full flex items-center justify-between gap-2 text-left text-[13px] text-[#334155] rounded-md px-2 py-1.5 hover:bg-[#f1f5f9] transition-colors">
                    <span className="flex items-center gap-2"><Circle className="h-3 w-3 text-[#c0392b]" /> {m.label[lang]}</span>
                    <ArrowRight className="h-3.5 w-3.5 text-[#94a3b8]" />
                  </button>
                </li>
              ))}
            </ul>
          </>
        )}
      </PopoverContent>
    </Popover>
  );
};
